/* ═══════════════════════════════════════════
   DRINGABRINGA – theme.js
   AJAX Add-to-Cart · Cart Update · Toast
════════════════════════════════════════════ */

/* ── TOAST ── */
let toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
}

/* ── UPDATE CART COUNT & TOTAL IN HEADER ── */
function updateCartCount(count, totalPrice) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
  });
  document.querySelectorAll('.cart-total').forEach(el => {
    if (count > 0) {
      el.textContent = formatMoney(totalPrice);
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });
}

/* ── FORMAT MONEY (Shopify cents → €) ── */
function formatMoney(cents) {
  return (cents / 100).toLocaleString('de-AT', { style: 'currency', currency: 'EUR' });
}

/* ── ADD TO CART (AJAX) ── */
async function addToCart(btn) {
  const variantId = btn.dataset.variantId;
  const title = btn.dataset.productTitle || 'Produkt';
  if (!variantId) return;

  btn.textContent = '…';
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Fehler beim Hinzufügen');

    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count, cart.total_price);

    btn.textContent = '✓';
    btn.classList.add('added');
    showToast('✅ ' + title + ' zum Warenkorb hinzugefügt');

    setTimeout(() => {
      btn.textContent = '+';
      btn.classList.remove('added');
      btn.disabled = false;
    }, 1400);

  } catch (err) {
    console.error(err);
    showToast('❌ Fehler – bitte nochmal versuchen');
    btn.textContent = '+';
    btn.disabled = false;
  }
}

/* ── REMOVE FROM CART (AJAX) ── */
async function removeFromCart(btn) {
  const variantId = btn.dataset.variantId;
  const title = btn.dataset.productTitle || 'Produkt';
  if (!variantId) return;

  btn.textContent = '…';
  btn.disabled = true;

  try {
    // Get current cart to find line item key and qty
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    const item = cart.items.find(i => String(i.variant_id) === String(variantId));

    if (!item) {
      btn.textContent = '−';
      btn.disabled = false;
      return;
    }

    const newQty = item.quantity - 1;

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: newQty })
    });

    if (!res.ok) throw new Error();

    const updatedCart = await res.json();
    updateCartCount(updatedCart.item_count, updatedCart.total_price);

    btn.textContent = '✓';
    showToast(newQty === 0 ? '🗑️ ' + title + ' entfernt' : '➖ ' + title + ' reduziert');

    setTimeout(() => {
      btn.textContent = '−';
      btn.disabled = false;
    }, 1400);

  } catch (err) {
    console.error(err);
    showToast('❌ Fehler – bitte nochmal versuchen');
    btn.textContent = '−';
    btn.disabled = false;
  }
}

/* ── UPDATE QTY ON CART PAGE ── */
async function updateQty(key, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!res.ok) throw new Error();
    window.location.reload();
  } catch {
    showToast('❌ Fehler – bitte Seite neu laden');
  }
}

/* ── LIVE CLOCK IN NAV BADGE ── */
function updateBadge() {
  const now = new Date();
  const h = String(now.getHours()).padStart(2, '0');
  const m = String(now.getMinutes()).padStart(2, '0');
  const badge = document.querySelector('.header-badge');
  if (badge) {
    badge.innerHTML = `<div class="live-dot"></div> 21:00–09:00 &nbsp;|&nbsp; ${h}:${m}`;
  }
}
updateBadge();
setInterval(updateBadge, 60000);
